import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { SMALLEST_HEADER_HEIGHT } from "@store/Overrides/Widgets/Header/LogoLinksSearch";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import { COMMON } from "@store/theme/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: StoreApplicationState) => {
    return {
        isSearchOpen: state.store.data.header.searchOpen,
        isStickyHeader: state.store.data.header.stickyHeader,
    };
};

export interface RightCornerFloatingWrapperStyles {
    wrapper?: InjectableCss;
}

const wrapperSize = `calc((100vw - (100vw - 100%) - ${COMMON.width.content}px) / 2)`;
const SMALLEST_HEADER_AND_SEARCH_HEIGHT = SMALLEST_HEADER_HEIGHT + 50;

export const rightCornerFloatingWrapperStyles: RightCornerFloatingWrapperStyles = {
    wrapper: {
        css: css`
            display: flex;
            position: fixed;
            align-items: center;
            min-width: 140px;
            min-height: 50px;
            opacity: 0;
            transition: opacity 0.2s ease;
            pointer-events: none;

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        { values: [null, "5px 0", null, "0 10px", "0"], properties: ["padding"] },
                        { values: [`${SMALLEST_HEADER_HEIGHT}px`, null, null, "inherit", null], properties: ["top"] },
                        { values: [null, null, null, "0", null], properties: ["right"] },
                        { values: [null, null, null, "5%", null], properties: ["bottom"] },
                        { values: ["100%", null, null, wrapperSize, null], properties: ["width"] },
                        { values: ["center", null, null, "right", "center"], properties: ["text-align"] },
                    ],
                    mediaOptions.min,
                )}

            &.is-wrapper-visible {
                opacity: 1;
                pointer-events: auto;
            }

            &.search-open {
                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [
                            {
                                values: [`calc(${SMALLEST_HEADER_AND_SEARCH_HEIGHT}px)`, "inherit", null, null, null],
                                properties: ["top"],
                            },
                        ],
                        mediaOptions.min,
                    )}
            }
        `,
    },
};

type OwnProps = WidgetProps & ReturnType<typeof mapStateToProps>;

const styles = rightCornerFloatingWrapperStyles;

const RightCornerFloatingWrapper: FC<OwnProps> = ({ id, isStickyHeader, isSearchOpen }) => {
    const visibleWrapper = isStickyHeader ? "is-wrapper-visible" : "";
    const searchOpen = isSearchOpen ? "search-open" : "";

    return (
        <>
            <StyledWrapper {...styles.wrapper} className={`${visibleWrapper} ${searchOpen}`}>
                <Zone contentId={id} zoneName="Buttons" />
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RightCornerFloatingWrapper),
    definition: {
        displayName: "Right Corner Floating Wrapper",
        group: "Common",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
